// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1cLFp","col":"CardReaderDesc_col__H_xmz","label":"CardReaderDesc_label__2tTUj"};